<template>
    <div class="courseList">
        <div class="filterArea" style="padding-left: 12px;">
            <span class="textLabel yellowTextLabel" :class="{active : timeFilterItem.id == selectedTimeFilter}"
                  v-for="timeFilterItem in timeFilterTypeList" :key="timeFilterItem.id"
                  @click="changeTimeFilter(timeFilterItem)">
                {{timeFilterItem.title}}
            </span>
        </div>

        <div class="list">
            <div class="item white_bg roundBorder8" v-for="dataItem in dataList"
                 :key="dataItem.id" data-click="viewItem(dataItem)">

                <div class="inner padding12">
                    <div class="flexLayout">

                        <div style="width: 150px; margin-right: 15px;">
                            <div class="imageArea relative" style="height: 90px">
                                <img class="fullSpace cover roundBorder8" :src="dataItem.coverImg"/>
                            </div>
                        </div>

                        <div class="flexItem">
                            <div class="titleArea grey20 hiddenOverflow" style="line-height: 20px; height: 42px;">
                                {{dataItem.title}}
                            </div>
                            <div class="f14" style="margin-top: 7px;">
                                <span class="red">￥{{dataItem.price}}</span>/共{{dataItem.segCount}}节
                                <span class="fr">{{dataItem.applyCount}}人在学</span>
                            </div>

                        </div>

                    </div><!-- end .flexLayout -->

                    <div class="grey f12" style="line-height: 36px; margin-top: 6px;">
                        <span class="textLabel courseLabel" style="margin-right: 12px;">精品课</span>
                        {{formatDateTime(dataItem.createTime)}}
                        <button class="viewIncomeButton fr" @click="viewIncome(dataItem)">查看收入</button>
                    </div>

                </div>

            </div>
        </div>

        <div class="alignCenter colorCCC bold paddingV16" v-show="status == 'ready' && dataList.length < 1">
            <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" />
        </div>

        <viewInComeDrawer ref="viewInComeDrawer" :currentDataItem="activeDataItem" />
    </div>
</template>

<script>
import generalCmpPart from "@comp/part/generalCmpPart";
import appHelper from "@util/appHelper";

//
import moment from "moment";

//
import viewInComeDrawer from './viewInComeDrawer';

const config = {
    apiConfig : {
        list : {
            url : 'portal/teacher/v2/getTeacherVodList',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
        }
    }
}

export default {
    extends : generalCmpPart,
    components : { viewInComeDrawer },
    data() {
        return {
            apiConfig : config.apiConfig,

            enableDataList : true,
            autoLoadDataList : true,

            timeFilterTypeList : [{
                title : '全部',
                id : null
            },{
                title : '今日',
                id : 1
            },{
                title : '本周',
                id : 2
            },{
                title : '本月',
                id : 3
            }],
            selectedTimeFilter : null,
            filters : {
                range : 0
            },

            activeDataItem : null
        }
    },
    methods : {
        changeTimeFilter(item) {
            this.selectedTimeFilter = this.filters.range = item.id;
            this.reloadDataList();
        },
        viewItem(dataItem) {
            appHelper.redirect('/liveTelecast/' + dataItem.id);
        },
        viewIncome(dataItem) {
            this.activeDataItem = dataItem;
            this.$refs.viewInComeDrawer.open();
        },
        formatDateTime(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD HH:mm');
        }
    },
    mounted() {
        // for (let i=0; i<3; i++)
        // {
        //     this.dataList.push({
        //         id : i,
        //         title : 'weherherh',
        //         price : '9.9',
        //         segmentCount : 3,
        //         learnCount: 284,
        //         createTime : new Date().getTime(),
        //         coverImg : appHelper.getRandomCoverImage()
        //     });
        // }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #F42418;
}
.filterArea {
    .textLabel {
        width: 56px;
        height: 22px;
        line-height: 22px;
        border: none;
        padding: 0;
        border-radius: 12px;
        margin-right: 16px;
        background-color: hsla(230, 30%, 96%, 1);
        text-align: center;
        font-size: 14px;
        color: hsla(219, 9%, 39%, 1);
        &.active {
            background-color: hsla(36, 100%, 57%, 1);
            color: white;
        }
    }
}
.courseLabel {
    height: 27px;
    line-height: 27px;
    background: transparent;
    padding: 0 8px;
    border: solid 1px #BBBBBB;
    border-radius: 4px;
    color: #101010;
}
.viewIncomeButton {
    border: solid 1px #F4950E;
    background: #F28500;
    border-radius: 8px;
    color: white;
    padding: 0 24px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
}
</style>
